import type { FaireProductEntity } from "../../entity_types/product";

export const p_ufxa5jb345: FaireProductEntity = {
  token: "p_ufxa5jb345",
  type: "product",
  name: "World Brighter Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7675fe85dd900d7872248d3f006b953bed3d74ddaa4152e249e25490501039b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd4ea0c0ac38dd77b6bac65bd438e09f83354f6c28e8e35b3a403fd93eeef03b.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:52.219Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
